var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { AppBar, Toolbar, Typography } from '@mui/material';
import React from 'react';
export var WindowToolbar = function (_a) {
    var title = _a.title, children = _a.children, otherProps = __rest(_a, ["title", "children"]);
    return (React.createElement(AppBar, __assign({ position: "static", elevation: 0 }, otherProps),
        React.createElement(Toolbar, { variant: "dense", style: { paddingRight: 0 } },
            React.createElement("div", { style: { flexGrow: 1 } }, typeof title === 'string' ? React.createElement(Typography, { variant: "h6" }, title) : title),
            children)));
};
